import React, { ReactNode } from "react";
import { useIsSmallScreen } from "../../App";
import { Padding } from "../../shared-components/Padding";
import { RUBRIC_COLOR, TEXT_INDENT, TEXT_SIZE } from "../../tokens";
import { SettingsButton, SettingsPanelId } from "./SettingsButton";

export const LegacyRubric: React.FC<{
    settingsPanelId?: SettingsPanelId;
    children: ReactNode;
}> = (props) => {
    const { children, settingsPanelId } = props;

    const isSmallScreen = useIsSmallScreen();

    return (
        <Padding onlySides>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                }}
            >
                {settingsPanelId ? (
                    <div style={{ width: 24, height: 24 }}></div>
                ) : (
                    <></>
                )}
                <div
                    style={{
                        paddingTop: 8,
                        paddingBottom: 8,
                        paddingLeft: isSmallScreen
                            ? TEXT_INDENT / 2
                            : TEXT_INDENT,
                        paddingRight: isSmallScreen
                            ? TEXT_INDENT / 2
                            : TEXT_INDENT,
                        color: RUBRIC_COLOR,
                        fontSize: isSmallScreen ? TEXT_SIZE * 0.9 : TEXT_SIZE,
                        textAlign: "center",
                        flexGrow: 1,
                    }}
                >
                    ❡&nbsp;&nbsp;{children}
                </div>
                {settingsPanelId ? (
                    <SettingsButton settingsPanelId={settingsPanelId} />
                ) : (
                    <></>
                )}
            </div>
        </Padding>
    );
};
